export const USER_INFO_JOBS = ['動物看護師（動物病院勤務）',
    '動物看護師（その他勤務）',
    '動物看護師（休職中）',
    'トリマー（動物病院勤務）',
    'トリマー（トリミングサロン勤務）',
    'トリマー（その他勤務）',
    'トリマー（休職中）',
    '動物看護学生（大学在籍）',
    '動物看護学生（専門学校在籍）',
    '高校生以下',
    '獣医師',
    '獣医学生',
    'その他'];
export default USER_INFO_JOBS;
